import { render, staticRenderFns } from "./HomeSwipe.vue?vue&type=template&id=2e7de65c&"
import script from "./HomeSwipe.vue?vue&type=script&lang=js&"
export * from "./HomeSwipe.vue?vue&type=script&lang=js&"
import style0 from "./HomeSwipe.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports